<template>
  <div>
    <div v-for="category in groupedData" :key="category.name" class="rbqm-menu-section">
      <div
        class="rbqm-menu-header"
        :class="{ expanded: !!mainMenuState[category.name] }"
        :style="{ borderLeft: '3px solid ' + (category.borderColor || 'transparent') }"
        @click.stop="toggleCategory(category.name)"
      >
        <!-- Click the button, not the header -->
        <div type="button" class="rbqm-toggle w-100">
          {{ category.name }}
        </div>
      </div>

      <div class="rbqm-rbqm-menu-items" v-show="!!mainMenuState[category.name]">
        <div v-for="sub in category.subcategories" :key="category.name + '::' + sub.name">
          <div
            class="rbqm-menu-item"
            :class="{ expanded: !!subMenuState[category.name + '-' + sub.name],
               activated: selectedSubKey === (category.name + '-' + sub.name)
             
            }"
            :style="{ borderLeft: '3px solid ' + (sub.borderColor || 'transparent') }"
            @click.stop="onSubCategoryClick(category.name, sub.name)"
          >
            <div
              type="button"
              class="rbqm-subtoggle w-100"
            >
              {{ sub.name }}
            </div>
          </div>

          <div class="rbqm-submenu"
          
           v-show="!!subMenuState[category.name + '-' + sub.name]">
            <div
              v-for="(detail, i) in sub.details"
              :key="category.name + '::' + sub.name + '::' + i"
              class="rbqm-submenu-item"
              :style="{ borderLeft: '3px solid ' + (sub.borderColor || 'transparent') }"
            >
              {{ detail }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script src="./rbqmNavbar.js">
</script>

<style scoped>
.activated {
  font-weight: 600;
}

.collapse {
  display: none;
}

.rotate-down {
  transform: rotate(90deg);
  transition: transform 0.2s ease;
}

.nav-third-level {
  padding-left: 1.5rem;
}

.thirdlevel {
  padding-left: 2rem;
  display: block;
}

.rbqm-menu-section {
  margin-bottom: 2px;
}

.rbqm-menu-header {
  padding: 2px 15px;
  background-color: #d4e8ff;
  color: #333333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.rbqm-menu-header:hover {
  background-color: #b9d8fc;
}

.rbqm-menu-header::after {
  content: "+";
  font-size: 18px;
}

.rbqm-menu-header.expanded::after {
  content: "-";
}

.rbqm-rbqm-menu-items {
  padding-top: 2px;
}

.rbqm-menu-item {
  padding: 2px 15px;
  margin-bottom: 2px;
  background-color: #e6f1ff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-left: 7px;
}

.rbqm-menu-item:hover {
  background-color: #daeaff;
}

.rbqm-menu-item::after {
  content: "+";
  font-size: 14px;
}

.rbqm-menu-item.expanded::after {
  content: "-";
}

.rbqm-submenu {
  margin-left: 14px;
  margin-top: 2px;
}

.rbqm-submenu-item {
  padding: 2px 10px;
  margin-bottom: 3px;
  background-color: #f8fbff;
  border: #e6f1ff 1px solid;
  font-size: 12px;
}
</style>